import { Grid, Typography } from '@mui/material';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { FormikNumberFormat } from 'src/common/components/formik';

export function FlatRateFeeFields(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>
        Calculated daily based on the entered rate and portfolio balance. All values are annual and will be pro-rated for the billing period.
        <b> Please note that the Rate (%) is inclusive of GST.</b>
      </Typography>
      <Field name={'feeTiers[0].valueWithGst'}>
        {(fieldProps: FieldProps) => {
          return (
            <FormikNumberFormat
              formikFieldProps={fieldProps}
              numberFormatProps={{
                placeholder: '0.00%',
                isNumericString: true,
                allowNegative: false,
                decimalScale: 2,
                thousandSeparator: true,
                suffix: '%',
                name: fieldProps.field.name,
                label: 'Rate (%)'
              }}
              isFloatValue={true}
              fullWidth={true}
            />
          );
        }}
      </Field>
    </Grid>
  );
}
